<template>
  <div class="title-box">
    <span class="title">{{ props.moduleData?.title }}</span>
  </div>
  <div class="custom-subList">
    <el-table
      class="custom-table"
      :data="tableData"
      border
      style="width: 100%"
      max-height="400px"
      header-cell-class-name="custom-header"
      show-overflow-tooltip
      table-layout="fixed"
    >
      <el-table-column
        min-width="120px"
        show-overflow-tooltip
        :label="item.title"
        v-for="(item, index) in dynamicColumns"
      >
        <template #default="scope" v-if="item.text">
          {{ dealShowVal(item.text(scope.row)) }}
        </template>
        <template #default="scope" v-else>
          {{ dealShowVal(scope.row[item.key]) }}
        </template>
      </el-table-column>
    </el-table>
    <div class="custom-pagination-box">
      <el-pagination
        class="custom-pagination-box123"
        v-model:current-page="paginationData.pageNum"
        v-model:page-size="paginationData.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup lang="tsx">
import { onMounted, type PropType, ref } from 'vue'
import { ColumnType } from '@/types/table'
import {
  dealTableValueConfig,
  getTableColumnWidthByCode,
  findField
} from '@/utils/preObjectManage/utils'
import { getUnionTableDataList } from '@/apis/objectManage'
import { isNullOrUndefOrEmpty, isEmpty, isString } from '@/utils/is'
import { getPageComponentDataEchoAcquire } from '@/apis/customerManage'
import { cloneDeep } from '@/utils/tools'

const props = defineProps({
  moduleData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  positions: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  columnPermission: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})

const tableData = ref<Recordable[]>([])
const paginationData = ref({
  pageSize: 20,
  pageNum: 1,
  total: 0
})
function handleSizeChange(val) {
  paginationData.value.pageSize = val
  getSubListData()
}
function handleCurrentChange(val) {
  paginationData.value.pageNum = val
  getSubListData()
}

// 判断条件知否都满足
function conditionCheck() {
  const conditionInfo = props.moduleData.conditionInfo || null
  let conditionFlag = true
  // 当前条件的rightValue值中
  if (conditionInfo && conditionInfo?.conditionList) {
    conditionFlag = conditionInfo?.conditionList.every((condis: Recordable) => {
      // 还要判断外部条件是and，还是or ， exteriorCondition
      // 还要判断内部条件是and，还是or , interiorCondition
      let flag = false // 当前这个外部条件是否为true的标识
      // 内部条件是否为true，还要取决于内部条件的AND还是OR
      if (condis.interiorCondition && condis.interiorCondition === 'AND') {
        flag = condis.conditions.every(condi => {
          if (condi.rightType === 10) {
            const field = findField(props.positions, condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          } else {
            return true
          }
        })
      } else {
        flag = condis.conditions.some(condi => {
          if (condi.rightType === 10) {
            const field = findField(props.positions, condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          } else {
            return true
          }
        })
      }
      return flag
    })
  }
  return conditionFlag
}
// 根据当前子表字段id获取子表数据
function getSubListData() {
  if (conditionCheck()) {
    const conditionInfo = props.moduleData.conditionInfo
      ? cloneDeep(props.moduleData.conditionInfo)
      : null
    if (conditionInfo && conditionInfo?.conditionList) {
      conditionInfo?.conditionList.forEach((condis: Recordable) => {
        condis.conditions.forEach((condi: Recordable) => {
          if (condi.rightType === 10) {
            const field = findField(props.positions, condi.rightColumnSerial)
            if (field && !isEmpty(field)) {
              let val = field?.renderConfig?.valCallback
                ? field.renderConfig.valCallback(props.formData[field.fieldCode])
                : props.formData[field.fieldCode]
              condi.rightValue = isString(val)
                ? JSON.stringify(val.split(','))
                : JSON.stringify(val)
            } else {
              condi.rightValue = JSON.stringify([])
            }
          }
        })
      })
    }
    console.log(props.moduleData, '哈哈哈哈')
    const columnDataList: Recordable[] = []
    props.moduleData.componentList.forEach((field: Recordable) => {
      const { unionTableColumnInfo, fieldSerial } = field.columnInfo
      console.log(unionTableColumnInfo, 'unionTableColumnInfo111')
      columnDataList.push({
        tableAlias: unionTableColumnInfo.unionTableAlias,
        tableField: unionTableColumnInfo.unionTableField,
        fieldCode: unionTableColumnInfo.unionFieldCode,
        fieldType: unionTableColumnInfo.unionFieldType,
        unionColumnSerial: unionTableColumnInfo.unionColumnSerial,
        fieldSerial,
        tableName: unionTableColumnInfo.unionTableName
      })
    })
    getUnionTableDataList({
      model: {
        columnList: columnDataList,
        unionTableCode: props.moduleData.columnTableCode,
        conditionInfo
      },
      pageNum: paginationData.value.pageNum,
      pageSize: paginationData.value.pageSize
    }).then(res => {
      console.log(res, 'pooooooooo')
      tableData.value = res.records
      paginationData.value.total = res.total
      // 数据获取之后需要echo
      dealColumnListData(tableData.value, () => {
        createTableColumns()
      })
    })
  }
}
const tableFieldList = ref([])
function dealColumnListData(tableData: Recordable[], fn: Fn) {
  // console.log(tableData, 'tableData123', props.moduleData.componentList)
  Promise.all(
    props.moduleData.componentList.map((field: Recordable) => {
      return (async () => {
        let arr: any[] = []
        const { dataMark, fieldSerial, id } = field || {}
        if (dataMark === 2) {
          tableData.forEach(item => {
            !isNullOrUndefOrEmpty(item[fieldSerial]) && arr.push(item[fieldSerial])
          })
          let dataList: Recordable[] = []
          if (arr.length) {
            await getPageComponentDataEchoAcquire({
              columnId: id,
              echoData: arr.join(',')
            })
              .then(res => {
                dataList = res
              })
              .catch(() => {
                dataList = []
              })
          }
          return { ...field, dataList }
        } else {
          return { ...field, dataList: field.columnDataList || [] }
        }
      })()
    })
  ).then(res => {
    tableFieldList.value = res
    console.log(tableFieldList, 'tableFieldList888')
    fn && fn()
  })
}

function dealShowVal(val: any) {
  if (isNullOrUndefOrEmpty(val)) {
    return '-'
  }
  return val
}

const dynamicColumns = ref<Recordable[]>([])

onMounted(() => {
  getSubListData()
  props.moduleData.associaFormEmitter.on('associaForm', moduleSerial => {
    if (moduleSerial === props.moduleData.moduleSerial) {
      getSubListData()
    }
  })
})
function createTableColumns() {
  console.log(tableFieldList.value, props.columnPermission, 'qqqq')
  dynamicColumns.value = tableFieldList.value
    .filter((field: Recordable) => props.columnPermission[field.fieldSerial])
    .map(field => {
      const { name, code, fieldSerial } = field

      let resultObj: ColumnType = {
        key: fieldSerial,
        title: name
      }
      // 设置每列的最小宽度,不手动设置的话则以通用规则设置
      if (!resultObj.minWidth && !resultObj.width) {
        resultObj.minWidth = getTableColumnWidthByCode(code)
      }
      const strategyFn = dealTableValueConfig[code]
      if (strategyFn) {
        resultObj.text = row => strategyFn(field, row[fieldSerial])
      }
      return resultObj
    })
  console.log(dynamicColumns, 'dynamicColumns111')
}
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.custom-subList {
  width: 100%;
  height: 100%;
  &.reHeight {
    height: calc(100% - 65px);
  }

  :deep(.el-table__body) {
    .el-table__cell {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-right-color: transparent;
      .cell {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
  :deep(.custom-header) {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background: #f4f4f5 !important;
    .cell {
      line-height: 40px;
      font-size: 14px;
      color: #666666;
      font-weight: 700;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.addRow {
  line-height: 48px;
  color: #5687ff;
}
.custom-pagination-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  .custom-pagination-box123 {
    border-top: none;
  }
}
</style>
